(() => {
  angular
    .module('gm.common.services')
    .factory('gmApi', gmApiService);

  function gmApiService(
    $q,
    $log,
    $http,
    GmyToken,
    Environment
  ) {
    'ngInject';

    const API_PREFIX = '/api/';
    const API_HOST = Environment.backend;
    const API_BASE_PATH = API_HOST + API_PREFIX;

    const errorListeners = [];

    return {
      getApiBasePath,
      getApiHost,
      getErrorMessage,
      get,
      hasErrorMessage,
      delete: deleteMethod,
      onError,
      patch,
      post,
      put,
    };

    function callApi(method, url, inputData = {}, origOptions = {}) {
      let options = angular.extend({
        method,
        url,
        data: inputData
      }, origOptions);
      options = prepareOptionsForCall(options);

      if (options.auth === true) {
        if (GmyToken.hasToken()) {
          options.headers['X-Auth-Token'] = GmyToken.getToken();
        } else {
          return $q.reject({
            status: 401,
            data: {
              message: 'need.auth'
            }
          });
        }
      }

      if (options.twoFactAuth && options.twoFactAuth.code) {
        options.headers['X-2FA-code'] = options.twoFactAuth.code;
      }

      if (options.twoFactAuth && options.twoFactAuth.requestSMS) {
        options.headers['X-2FA-ForceSMS'] = options.twoFactAuth.requestSMS;
      }

      if (options.captcha) {
        options.headers['X-Captcha-Code'] = options.captcha;
      }

      return $q((resolver, rejector) => {
        $http(options)
          .then(({ data, status, headers }) => {
            if (options.token === true) {
              if (headers('X-Auth-Token') !== null) {
                GmyToken.setToken(headers('X-Auth-Token'));
              }
            }

            if (options.returnHeaders) {
              resolver([data, headers]);
            } else if (options.returnStatus) {
              resolver({
                status,
                response: data
              });
            } else {
              resolver(data);
            }
          }, ({ data, status }) => rejector(generateErrorObject(data, status)));
      })
      .catch((error) => {
        angular.forEach(errorListeners, fn => fn(error));
        $log.debug(error);

        return $q.reject(error);
      });
    }

    function deleteMethod(url, options) {
      return callApi('DELETE', url, null, options);
    }

    function get(url, options) {
      return callApi('GET', url, null, options);
    }

    function getApiBasePath() {
      return API_BASE_PATH;
    }

    function getApiHost() {
      return API_HOST;
    }

    function getErrorMessage(error) {
      return hasErrorMessage(error) && error.data.message;
    }

    function generateErrorObject(data, status) {
      return {
        data,
        status: status || 0
      };
    }

    function hasErrorMessage(error) {
      return (!angular.isUndefined(error)) && (error !== null) && ('data' in error)
        && (!angular.isUndefined(error.data)) && (error.data !== null)
        && ('message' in error.data) && (error.data.message !== null) && (error.data.message.length > 0);
    }

    function onError(cb) {
      errorListeners.push(cb);
    }

    function patch(url, data, options) {
      return callApi('PATCH', url, data, options);
    }

    function post(url, data, options) {
      return callApi('POST', url, data, options);
    }

    function prepareOptionsForCall(origOptions) {
      let options = origOptions;
      if (angular.isString(options)) {
        options = {
          url: options
        };
      }

      options.url = API_BASE_PATH + options.url;

      if (!angular.isString(options.method)) {
        options.method = 'GET';
      }

      if (!angular.isString(options.responseType)) {
        options.responseType = 'json';
      }

      if (!angular.isObject(options.headers)) {
        options.headers = {
          'Content-Type': 'application/json;charset=UTF-8'
        };
      }

      if (options.file === true) {
        options.transformRequest = angular.identity;
        options.headers['Content-Type'] = undefined;
      }

      return options;
    }

    function put(url, data, options) {
      return callApi('PUT', url, data, options);
    }
  }
})();
